<template>
  <div style="height: 100%;" :style="{overflow: view.includes('graph') ? 'hidden' : 'auto'}">
    <div class="v-data-table-off-overflow" v-if="isLoaded">
      <v-data-table
        v-if="view === 'table1'"
        dense
        :items="table.table"
        :headers="headers"
        disable-pagination
        hide-default-footer
        fixed-header
      ></v-data-table>

      <div style="overflow: hidden;" class="apex-hidden-scrollbar">
        <apexchart
          v-show="view === 'graph1'"
          type="pie"
          :options="chartOptions"
          :series="series"
        />
      </div>
      
    </div>

    <v-progress-linear
      v-else
      indeterminate
      color="success"
    ></v-progress-linear>
  </div>
</template>


<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'OutgoingByOperators',
  props: {
    view: String,
    widget: Object,
  },
  data() {
    return {
      isLoaded: false,

      table: {},
      headers: [
        {text: 'SIP', value: 'agent_sip'},
        {text: 'Имя', value: 'title'},
        {text: 'Звонков', value: 'calls_count'},
        {text: 'Время разговора', value: 'talk_duration'},
        {text: 'Среднее время разговора', value: 'avg_talk_duration'},
        {text: '%', value: 'percent'},
      ],

      chartOptions: {
        chart: {
          type: 'pie',
          background: '#00000000'
        },
        legend: {
          show: false,
          // position: 'bottom'
        },
        colors: [
          '#4CAF50',
          '#FF9800',
        ],
        labels: [
          'Принятые',
          'Пропущенные',
        ],
        theme: {
          mode: 'dark'
        },
        // tooltip: {
        //   theme: 'dark',
        //   custom: this.tooltip,
        // },
      },
      series: [],
    }
  },

  computed: {
    ...mapGetters({
    }),

    isDarkTheme() {
      return this.$vuetify.theme.isDark;
    },
  },

  watch: {
    isDarkTheme() {
      this.changeApexTheme();
    },

    view() {
      window.dispatchEvent(new Event('resize')) //Очередной костылик для отрисовки "бублика"
    },

  },

  methods: {
    ...mapActions({
      loadOutgoingByOperators: 'dashboard/loadOutgoingByOperators',
    }),

    changeApexTheme() {
      if (this.isDarkTheme) {
        this.chartOptions = {
          chart: {
            background: '#00000000'
          },
          theme: {
            mode: 'dark',
          },
        };
      } else {
        this.chartOptions = {
          chart: {
            background: '#00000000'
          },
          theme: {
            mode: 'light',
          },
        };
      }
    },

    async loadData() {
      this.isLoaded = false;
      this.table = await this.loadOutgoingByOperators(this.widget.params);
      this.fillItemsForApex(this.table.bublik);
      this.isLoaded = true;
    },

    fillItemsForApex(items) {
      let options = JSON.parse(JSON.stringify(this.chartOptions));
      // Это извращение чтоб чарты нормально свои опции подхватывали =(((
      setTimeout(() => {
        this.series = [];
        this.series.push(+items.accepted_calls_count);
        this.series.push(+items.missed_calls_count);

        this.chartOptions = Object.assign(this.chartOptions, options);
      }, 500);
    },
  },
  
  async mounted() {
    await this.loadData();
    this.changeApexTheme();
  },
}
</script>


<style scoped lang="scss">

</style>